'use client';

import * as React from 'react';

import { CancellationPolicy } from './cancellation-policy';

interface ListingCancellationPolicySectionProps {
  cancellationPolicy: string;
}

export const ListingCancellationPolicySection: React.FC<
  ListingCancellationPolicySectionProps
> = ({ cancellationPolicy }) => {
  return <CancellationPolicy cancellationPolicy={cancellationPolicy} />;
};
